import React from "react";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky";
const GCReverse = ({
  fCloseReverseTransactionModal,
  sRevNarr,
  setRevNarr,
  fReverse,
  open,
}) => {
  useEffect(() => {
    document?.getElementById("GCReverse")?.focus();
  }, []);
  return (
    <Modal
      open={open}
      onClose={fCloseReverseTransactionModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="model-Reverse-small-box">
      <GCTitleSticky
        title={'Reverse Narration'}
        onClose={fCloseReverseTransactionModal}
        />
        
        {/* <div className="d-flex justify-content-between wms-label my-2">
        <div>Reverse Narration</div>{" "}
        <CloseIcon onClick={fCloseReverseTransactionModal} />
      </div> */}
        <div className="p-3">
          <input
            autoComplete="off"
            className="form-control form-control-sm my-4"
            id="GCReverse"
            type="text"
            name="sRevNarr"
            value={sRevNarr}
            onChange={(e) => {
              setRevNarr(e.target.value);
            }}
          />
          {/* <span className={sRevNarr != "" ? "hide-error" : "show-error"}>{"Required"}</span> */}
          <div className="text-end">
            <button
              type="button"
              className="btn btn-primary"
              disabled={sRevNarr == ""}
              onClick={fReverse}
            >
              Reverse
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default GCReverse;
